import { createActions } from "redux-actions";

const actions = createActions(
  {
    MESSAGE: (message) => ({ message }),
    TOKEN: (fcmToken, receivedOnStartUp = false) => ({
      fcmToken,
      receivedOnStartUp,
    }),
  },
  { prefix: "FIREBASE" },
);

export const {
  message,
  token,
} = actions;

